// extracted by mini-css-extract-plugin
export default {"dark":"ContactPage_dark__vPyMB","root":"ContactPage_root__HMjyl","wrapper":"ContactPage_wrapper__PwUtm","container":"ContactPage_container__y7+cD"};